import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import SnackbarAlert from '../common/SnackbarAlert';
import request from 'src/utils/request';

CancelAlert.propTypes = {
  cancelopen: PropTypes.bool,
  cancelType: PropTypes.string,
  closeCancelModal: PropTypes.func,
  cancelPolicyRequest: PropTypes.func
};

export default function CancelAlert({
  cancelopen,
  cancelType,
  closeCancelModal,
  cancelPolicyRequest
}) {
  const [showSnackBarAlert, setShowSnackBarAlert] = React.useState({
    status: false,
    type: 'success',
    message: null
  });

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <>
      <Dialog
        open={cancelopen}
        keepMounted
        onClose={() => closeCancelModal()}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <Button sx={{
            cursor: 'default',
            textDecoration: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            }
          }}
          >
            <Icon icon={trash2Outline} width={22} height={22} color="red" />
            &nbsp;&nbsp;&nbsp;
            <Typography variant="h6" color="black">
              {cancelType === 'Cancelled'
                ? 'Cancel Policy'
                : cancelType === 'CancelledAndReissued'
                  ? 'Update Policy Details'
                  : ''}
            </Typography>
          </Button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {cancelType === 'Cancelled'
              ? 'Are you sure you want to Cancel Policy?'
              : cancelType === 'CancelledAndReissued'
                ? 'Are you sure you want to Update Policy Details?'
                : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeCancelModal()}
            variant="contained"
            color="error"
          >
            No
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => cancelPolicyRequest()}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
    </>
  );
}
